import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AgentApiAllianceSettingShow } from '@/types/serializers';
import { ALLIANCE_SETTING_QUERY_KEY } from './useFetchAllianceSetting';

export default function useUploadAllianceLogo() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (file: Blob) => {
      const formData = new FormData();
      formData.append('logo', file, 'logo.png');

      const response = await fetch('/agent/api/alliance_setting/update_logo', {
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });

      if (!response.ok) {
        let errorMessage = 'ロゴのアップロードに失敗しました';
        try {
          const errorData: { error?: string; errors?: string[] } = await response.json();
          errorMessage = errorData.errors?.[0] || errorData.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      const data: AgentApiAllianceSettingShow = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALLIANCE_SETTING_QUERY_KEY });
    },
  });
}
